export const msalConfig = {
  auth: {
    clientId: "07cc864d-659d-453e-8b5e-bde039875e96",
    authority: "https://excelea.b2clogin.com/excelea.onmicrosoft.com/B2C_1_login",
    knownAuthorities: ["excelea.b2clogin.com"],
    redirectUri: "https://app.excelea.com",
    postLogoutRedirectUri: "https://app.excelea.com"
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false
  }
};

export const loginRequest = {
  scopes: ["openid", "profile", "email", "offline_access"]
}; 